import React from "react";
import { Link } from "react-router-dom";
import "./About.css";
import Footer from "../Footer";
import studioPhoto from "../../assets/images/homepage/studiophoto.png";
import { DollarIcon, PaletteIcon, ShieldCheckIcon } from "../public/icons";

const principles = [
  {
    title: "We don't take a cut",
    description:
      "A flat fee, whether you book two clients a week or twenty. Growing shouldn't cost you more.",
    icon: DollarIcon,
    tone: "clay",
  },
  {
    title: "Your name above ours",
    description:
      "The booking page belongs to your business. We stay out of the way of your brand.",
    icon: PaletteIcon,
    tone: "sage",
  },
  {
    title: "Small on purpose",
    description:
      "We say no to most feature requests so the ones you use every day stay fast and obvious.",
    icon: ShieldCheckIcon,
    tone: "clay",
  },
];

const About = () => (
  <>
    <main className="about-page">
      <section className="site-section site-section--hero about-hero">
        <span className="deco deco--1 about-hero__deco" aria-hidden="true" />
        <div className="site-inner">
          <div className="about-hero__copy">
            <p className="eyebrow">About</p>
            <h1>We started by sitting in salon chairs and asking questions.</h1>
            <p className="lead about-hero__lead">
              Haastia came out of a long series of conversations with stylists, nail techs and
              lash artists about the part of the job nobody photographs: the deposit that never
              arrived, the client who ghosted, the Sunday spent typing appointment times into a
              phone.
            </p>
          </div>
        </div>
      </section>

      <section className="site-section site-section--flush-top about-story">
        <div className="site-inner">
          <div className="about-story__grid">
            <img
              className="washed about-story__photo"
              src={studioPhoto}
              alt="A stylist in her own studio between clients"
              loading="lazy"
            />
            <div>
              <h2>What we kept hearing</h2>
              <p>
                That the tools were either free and chaotic, or expensive and built for a front
                desk that doesn't exist when you work alone. That taking a deposit felt awkward.
                That the booking link had someone else's logo on it.
              </p>
              <p>
                So we built the small version on purpose: one page, one calendar, one payment
                flow, priced like a phone bill rather than a business system.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="site-section site-section--tinted about-principles">
        <div className="site-inner">
          <h2 className="about-principles__title">Three things we won't trade away</h2>
          <div className="about-principles__grid">
            {principles.map(({ title, description, icon: Icon, tone }) => (
              <div className="about-principle" key={title}>
                <span
                  className={`icon-circle icon-circle--lg${tone === "sage" ? " icon-circle--sage" : ""}`}
                >
                  <Icon size={24} />
                </span>
                <h3>{title}</h3>
                <p>{description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="site-section about-cta">
        <div className="site-inner">
          <div className="panel panel--surface about-cta__panel">
            <div>
              <h2>Still interviewing, still listening.</h2>
              <p>
                If something about the way you work doesn't fit Haastia, we'd rather hear it than
                guess. Tell us.
              </p>
            </div>
            <div className="btn-row">
              <Link className="btn btn-primary btn-md" to="/contact">
                Talk to us
              </Link>
              <Link className="btn btn-secondary btn-md" to="/help">
                Read the help center
              </Link>
            </div>
          </div>
        </div>
      </section>
    </main>
    <Footer />
  </>
);

export default About;
